import { render, staticRenderFns } from "./outsource-performance-manage.vue?vue&type=template&id=128cf310"
import script from "./outsource-performance-manage.vue?vue&type=script&lang=ts"
export * from "./outsource-performance-manage.vue?vue&type=script&lang=ts"
import style0 from "./outsource-performance-manage.vue?vue&type=style&index=0&id=128cf310&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports